(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[35983],{

/***/ 72121:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stripe/singapore-stripe-fees-for-marketplace-platform-model",
      function () {
        return __webpack_require__(74947);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 74947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MDXContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3905);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5679);
/* harmony import */ var _partials_Cta__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74756);



/* @jsxRuntime classic */ /* @jsx mdx */ 


var Layout = (__webpack_require__(7346)/* .RootFileLayout */ .k);
var meta = {
    "title": "\uD83C\uDDF8\uD83C\uDDEC Singapore Stripe Fees for marketplace / platform model",
    "date": "2021-03-04"
};
var slug = "singapore-stripe-fees-for-marketplace-platform-model";
var tableOfContents = [
    {
        "title": "If you are looking for video explanation",
        "slug": "if-you-are-looking-for-video-explanation",
        "children": []
    },
    {
        "title": "Definitions to understand",
        "slug": "definitions-to-understand",
        "children": []
    },
    {
        "title": "How Tradly and Stripe works together",
        "slug": "how-tradly-and-stripe-works-together",
        "children": []
    },
    {
        "title": "Stripe Payment Processing Fee",
        "slug": "stripe-payment-processing-fee",
        "children": [
            {
                "title": "Charges 3.4% + S$0.50 per successful card charge",
                "slug": "charges-3-4-s-0-50-per-successful-card-charge",
                "children": []
            }
        ]
    },
    {
        "title": "Stripe Payout Charges for marketplaces",
        "slug": "stripe-payout-charges-for-marketplaces",
        "children": [
            {
                "title": "S$2 per monthly active account*",
                "slug": "s-2-per-monthly-active-account",
                "children": []
            },
            {
                "title": "0.25% + S$0.50 per payout sent",
                "slug": "0-25-s-0-50-per-payout-sent",
                "children": []
            }
        ]
    },
    {
        "title": "Time taken for different steps",
        "slug": "time-taken-for-different-steps",
        "children": []
    },
    {
        "title": "Example calculation",
        "slug": "example-calculation",
        "children": []
    }
];
var layoutProps = {
    Layout: Layout,
    meta: meta,
    slug: slug,
    tableOfContents: tableOfContents
};
var MDXLayout = (__webpack_require__(87274)/* .CustomContentsLayout */ .NH);
function MDXContent(_param) {
    var components = _param.components, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "components"
    ]);
    return /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(MDXLayout, Object.assign({}, layoutProps, props, {
        components: components,
        mdxType: "MDXLayout"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Are the stripe processing fee and pricing confusing to you? Here are the Singapore Stripe Fees example and calculator to give you clarity. The below examples suit if you are running a p", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "p"
    }, {
        "href": "https://tradly.app"
    }), "marketplace platform"), ", subscription billing, and custom two-sided logic."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Example of companies which falls under this model are Amazon, Airtasker, Instacart, Lyft, Deliveroo, Postmates, Etsy, Depop, etc"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Launch marketplaces in Singapore with Tradly. White label software and builder for ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: "/create-multi-vendor-marketplace",
        passHref: true
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", null, "Multi Vendor Marketplaces")), ", ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: "/saas/partnerplatform",
        passHref: true
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", null, "App Stores")), ", Storefronts, ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: "/booking",
        passHref: true
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", null, "Booking-service-tickets")), ", ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: "/donation/fundraising-donation-management-platforms",
        passHref: true
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", null, "Crowdfunding")), ", On Demand Delivery. Fast, FREE, and Pay as you grow. A simple no-code tool for start + Headless API for scale."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_partials_Cta__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        mdxType: "Cta"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "if-you-are-looking-for-video-explanation",
        nextElement: {
            "type": "paragraph"
        }
    }, "If you are looking for video explanation"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Here is short video: "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("div", {
        class: "aspect-w-16 aspect-h-9"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("iframe", {
        width: "100%",
        height: "100%",
        src: "https://www.youtube.com/embed/gPy3TRB88rY",
        frameborder: "0",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        allowfullscreen: true
    })), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Here is a long video which is explained using Tradly Marketplace Apps. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("div", {
        class: "aspect-w-16 aspect-h-9"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("iframe", {
        width: "100%",
        height: "100%",
        src: "https://www.youtube.com/embed/rCN4auGW4X4",
        frameborder: "0",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        allowfullscreen: true
    })), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "definitions-to-understand",
        nextElement: {
            "type": "list",
            "ordered": false,
            "start": null,
            "spread": false
        }
    }, "Definitions to understand"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Platforms means your marketplace. or the platform you run. Exmaple: Amazon"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Payment: Money going into Stripe Connect when a user make transaction"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Payout: The Money goes out to seller ")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "how-tradly-and-stripe-works-together",
        nextElement: {
            "type": "paragraph"
        }
    }, "How Tradly and Stripe works together"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "This applies to most product marketplaces with commission as revenue model. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        src: (__webpack_require__(27797)/* ["default"] */ .Z),
        alt: "Aqua-Marketplace",
        width: "700"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "The flow of Stripe Charges, Payout, and Tradly Triggers. ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "p"
    }, {
        "href": "https://tradly.app"
    }), "Launch Marketplaces with Stripe connect and Tradly API")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "stripe-payment-processing-fee",
        nextElement: {
            "type": "heading",
            "depth": 3
        }
    }, "Stripe Payment Processing Fee"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "charges-3-4-s-0-50-per-successful-card-charge",
        nextElement: {
            "type": "paragraph"
        }
    }, "Charges 3.4% + S$0.50 per successful card charge"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "p"
    }, {
        "href": "https://tradly.app"
    }), "Tradly"), " supports standard and express but the marketplace needs Express because it allows “Separate Charges and Transfer” logic."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "stripe-payout-charges-for-marketplaces",
        nextElement: {
            "type": "heading",
            "depth": 3
        }
    }, "Stripe Payout Charges for marketplaces"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "s-2-per-monthly-active-account",
        nextElement: {
            "type": "paragraph"
        }
    }, "S$2 per monthly active account*"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "*", " An account is active in any month payouts are sent to their bank account or debit card. Includes ongoing onboarding, verification, and compliance."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "0-25-s-0-50-per-payout-sent",
        nextElement: {
            "type": "paragraph"
        }
    }, "0.25% + S$0.50 per payout sent"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "The stripe connect fee for Singapore Marketplaces Platforms"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "time-taken-for-different-steps",
        nextElement: {
            "type": "list",
            "ordered": false,
            "start": null,
            "spread": false
        }
    }, "Time taken for different steps"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Payment Charges (Immediately seen in your account but will not be added in balances, it takes 2-5days)"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Transfers (Immediate if you have positive balance)"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Payout (Payout will take another 2-5days depends on the bank)")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "example-calculation",
        nextElement: {
            "type": "paragraph"
        }
    }, "Example calculation"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "p"
    }, {
        "href": "https://docs.google.com/spreadsheets/d/1JVmwtW1cFccYc-nCoK6pndIGYNTl4Ny2WAy1ErTtos0/edit#gid=1798867797"
    }), "Use this sheet if you want to do your own calculation")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        src: (__webpack_require__(18242)/* ["default"] */ .Z),
        width: "700"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Stripe Fee calculation"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        src: (__webpack_require__(47034)/* ["default"] */ .Z),
        width: "700"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_partials_Cta__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        mdxType: "Cta"
    }));
}
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [73320,85220,96401,48777,26852,5679,75240,49774,92888,40179], function() { return __webpack_exec__(72121); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);